import { Navigate } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { Google } from '@mui/icons-material'
import GradientCard from '@/components/GradientCard'
import { PageContainer, CardWrapper, FormWrapper, Form, LinksWrapper, Link } from './styles'
import { useTranslation } from 'react-i18next'
import { API_PATHS } from '@/constants'
import { useAuth } from '@/contexts/AuthContext'

function LoginPage() {
  const { t } = useTranslation()
  const { user, loading } = useAuth()

  if (loading) return null

  if (user) return <Navigate to="/" replace />

  const handleGoogleLogin = () => {
    window.location.href = `${import.meta.env.VITE_API_URL}${API_PATHS.AUTH.GOOGLE}`
  }

  return (
    <PageContainer>
      <CardWrapper>
        <GradientCard />
      </CardWrapper>
      <FormWrapper>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            {t('welcome')}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: 6, color: '#5D6B82' }}>
            {t('start_new_session')}
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<Google />}
            onClick={handleGoogleLogin}
            sx={{ height: 48, textTransform: 'none', fontWeight: 600 }}
          >
            {t('login_with_google')}
          </Button>
        </Form>
        <LinksWrapper>
          <Link href={t('links.help')} target="_blank">
            <Typography sx={{ fontWeight: 500 }}>{t('help')}</Typography>
          </Link>
          <Link href={t('links.terms_conditions')} target="_blank">
            <Typography sx={{ fontWeight: 500 }}>{t('terms_conditions')}</Typography>
          </Link>
        </LinksWrapper>
      </FormWrapper>
    </PageContainer>
  )
}

export default LoginPage
